import type { FC } from 'react';

import { NavigationItem } from './components/NavigationItem';
import {
    LogoContainer,
    NavContainer,
    NavList,
    CloseContainer,
    StyledLink,
} from './styled';

import { useNavigationContext } from '../../context/navigation';
import { Icon, IconName } from '../Icon';

export interface INavItem {
    to: string;
    exact?: boolean;
    label: string;
}

interface INavigationProps {
    onClose?: () => void;
}

export const Navigation: FC<INavigationProps> = ({ onClose }) => {
    const { navItems, homepageUrl } = useNavigationContext();
    return (
        <NavContainer>
            <LogoContainer>
                <StyledLink to={homepageUrl ?? '/'}>
                    <Icon iconName={IconName.LOGO_LIGHT} />
                </StyledLink>
                <CloseContainer onClick={onClose}>
                    <Icon iconName={IconName.CLOSE} />
                </CloseContainer>
            </LogoContainer>

            <NavList>
                {navItems.map(({ label, ...props }) => (
                    <NavigationItem key={props.to} {...props}>
                        {label}
                    </NavigationItem>
                ))}
            </NavList>
        </NavContainer>
    );
};

Navigation.defaultProps = {
    onClose: undefined,
};
